import type { PieceLogoRenderable } from './pieceLogoRenderable';

export type ModelLogoRenderable = PieceLogoRenderable & {
  meshId: string;
};

/**
 * Create piece logo.
 * @param id - Piece logo ID.
 */
export const create = (id: string, meshId: string): ModelLogoRenderable => {
  return { id, meshId } as ModelLogoRenderable;
};
